
import { cloneDeep } from 'lodash';
import Vue from 'vue'
import type { IPropertyGroup, IPropertyGroupValue } from '~/types/product';

const maxLines = 18;

export default Vue.extend({
    props: ['values'],
    data: () => ({opened: false}),
    methods: {
        transformGroupDimentions(group: IPropertyGroup) {
            
            const dimentionRegex = /^(.*)\s\((.*)\)$/u;

            const result = dimentionRegex.exec(group.name);

            if (result) {
                group.name = result[1]!;
                group.props.forEach((row: any) => {
                    row.value += ` ${result[2]}`;
                })
            }

            const props: IPropertyGroupValue[] = [];

            group.props.forEach((row: any) => {
                const result = dimentionRegex.exec(row.name);
                if (result) {
                    row.name = result[1];
                    row.value += ` ${result[2]}`;
                }

                const existsProp = props.find((el) => el.name === row.name);
                if (!existsProp) {
                    props.push(row);
                } else {
                    existsProp.value += `\n${row.value}`;
                }
            });

            group.props = props;
        }

    },
    computed: {
        transformedProps() {
            const result = cloneDeep(this.values);
            result.forEach(group => {
                this.transformGroupDimentions(group);
            });

            return result;
        },
        displayProps() {
            if (this.opened) {
                // @ts-ignore
                return this.transformedProps;
            } else {
                let count = 0;
                const result = [];

                (this.transformedProps as any[]).forEach((el) => {

                    if (count > maxLines - 3) {
                        return;
                    }

                    if (count) {
                        count++;
                    }
                    count++;
                    if (el.props.length <= maxLines - count) {
                        result.push(el);
                        count += el.props.length;
                    } else {
                        result.push({
                            name: el.name,
                            props: el.props.slice(0, maxLines - count),
                        });

                        count = maxLines + 1;
                    }
                });

                return result;
            }
        },
        totalLines() {

            let lines = 0;

            (this.values as any[]).forEach((el, i) => {
                lines += el.props.length + 1 + (i !== 0);
            });

            return lines;
        },
        needShowMore() {
            return (this as any).totalLines > maxLines;
        },
        showMoreText() {
            return this.opened ? 'Свернуть описание' : 'Развернуть описание';
        }
    }
})
